const $ = require('./js/plugins/jquery.min');
global.$ = global.jQuery = $;
require('./js/src/modules');
require('./js/plugins/jquery.validate.min');
const swiper = require('./js/plugins/swiper/swiper.min.js');
require('./js/plugins/swiper/swiper.min.css');
global.Swiper = swiper;
require('./js/plugins/jquery.inputmask.min.js');
require('./js/src/burger');
require('./js/src/select');
require('./js/src/checkbox');
require('./js/src/mask');
require('./js/src/radio');
require('./js/src/popups');
require('./js/src/preloader');
require('./js/src/main');
require('./js/src/ajax');
require('./js/src/validation');
require('./js/src/validation_forms');
require('./js/src/modal');
require('./js/src/sliders');
require('./js/src/captcha');

require('./css/basic.css');
require('./css/style-bundle.css');
require('./css/normalize.css');
require('./css/authorization.css');
require('./css/temp.css');

jQuery(function () {
  global.modules.init();
})